import { NoteText } from "@/components/notes";
import { localized } from "@msuite/ui/localization";
import {
	createColumnHelper,
	createMeta,
	createRowActions,
	createSubRowHandle,
} from "@msuite/ui/table";
import { UnitTag } from "@msuite/ui/tag";
import { formatNumber } from "@msuite/utils/numbers";
import { getCalculationResultString } from "@msuite/utils/services";
import { guardString } from "@msuite/utils/strings";
import type { Tables } from "@msuite/utils/types";
import { CalculationServiceItemAtomicNumber } from "./calculation-service-item-atomic-number";
import { RowActions } from "./row-actions";

const columnHelper = createColumnHelper<Tables<"serviceCalculationItems">>();

export const columns = [
	createSubRowHandle<Tables<"serviceCalculationItems">>(),
	columnHelper.accessor("ranking", {
		id: "atomicNumber",
		header: localized("organization.data.atomic_number"),
		cell: (cell) => <CalculationServiceItemAtomicNumber item={cell.row.original} />,
		meta: createMeta({
			isTabular: true,
		}),
	}),
	columnHelper.accessor("shortText", {
		id: "shortText",
		header: localized("organization.data.short_text"),
		cell: (cell) => cell.getValue(),
	}),
	columnHelper.accessor("longText", {
		id: "longText",
		header: localized("organization.data.long_text"),
		cell: (cell) => <NoteText note={cell.getValue() || guardString(null)} />,
	}),
	columnHelper.accessor("unitPrice", {
		id: "unitPrice",
		header: localized("organization.data.unit_price"),
		cell: (cell) => formatNumber(cell.getValue(), "currency"),
		meta: createMeta({
			isNumeric: true,
		}),
	}),
	columnHelper.accessor("unit", {
		id: "unit",
		header: localized("units.unit"),
		cell: (cell) => <UnitTag unit={cell.getValue()} />,
	}),
	columnHelper.display({
		id: "result",
		header: localized("calculations.result"),
		cell: (cell) => `${getCalculationResultString(cell.row.original)}`,
		meta: createMeta({
			isNumeric: true,
		}),
	}),
	columnHelper.accessor("total", {
		id: "total",
		header: localized("invoices.sum_net"),
		cell: (cell) =>
			cell.row.original.isEventualPosition ? "E.P." : formatNumber(cell.getValue(), "currency"),
		meta: createMeta({
			isNumeric: true,
		}),
	}),
	createRowActions(RowActions),
];
